import React from "react";

import AppNavigation2g, { AppNavigationItem } from "2g-app-navigation";
import { Icons } from "2g-icons";
import { useAuthProvider } from "2g-auth";

import { PATHS } from "b2b/constants";
import Authorized from "b2b/components/auth";

import useMessages from "./i18n/navigation/useMessages";

export function AppNavigation() {
  const messages = useMessages();
  const { userInfo } = useAuthProvider();

  return (
    <>
      <AppNavigation2g title={messages.title()}>
        <AppNavigationItem link={PATHS.PREHLED} icon={Icons.Dashboard}>
          {messages.itemPrehled()}
        </AppNavigationItem>
        <AppNavigationItem
          link={PATHS.REZERVACE.BASE}
          icon={Icons.CalendarCheck}
        >
          {messages.itemRezervace()}
        </AppNavigationItem>
        <AppNavigationItem
          link={PATHS.PROVOZNI_INFORMACE.LIST}
          icon={Icons.Informations}
        >
          {messages.itemProvozniInformace()}
        </AppNavigationItem>
        <AppNavigationItem
          link={PATHS.ADMINISTRACE.BASE}
          icon={Icons.SettingsLight}
          renderable={userInfo.isUserInRole(["admin", "vuz_spravce"] || false)}
        >
          {messages.itemAdministrace()}
        </AppNavigationItem>
      </AppNavigation2g>

      <AppNavigation2g submenuPath={PATHS.REZERVACE.BASE}>
        <AppNavigationItem
          link={PATHS.REZERVACE.CASOVY_PLAN}
          icon={Icons.CalendarClock}
        >
          {messages.itemRezervaceCasovyPlan()}
        </AppNavigationItem>
        <AppNavigationItem
          link={PATHS.REZERVACE.HISTORIE}
          icon={Icons.CalendarMagnifier}
        >
          {messages.itemRezervaceHistorie()}
        </AppNavigationItem>
        <AppNavigationItem
          link={PATHS.REZERVACE.ODBAVENI}
          icon={Icons.CalendarArrow}
          renderable={userInfo.isUserInRole([
            "admin",
            "vuz_spravce",
            "vuz_edit"
          ])}
        >
          {messages.itemRezervaceOdbaveni()}
        </AppNavigationItem>
        <AppNavigationItem
          link={PATHS.REZERVACE.VYTVORENI}
          icon={Icons.CalendarPlus}
        >
          {messages.itemRezervaceVytvoreni()}
        </AppNavigationItem>
      </AppNavigation2g>

      <Authorized roles={["admin", "vuz_spravce"]}>
        <AppNavigation2g submenuPath={PATHS.ADMINISTRACE.BASE}>
          <AppNavigationItem
            link={PATHS.ADMINISTRACE.ZAKAZNICI}
            icon={Icons.User2}
          >
            {messages.itemAdministraceZakaznici()}
          </AppNavigationItem>
          <AppNavigationItem
            link={PATHS.ADMINISTRACE.ZDROJE}
            icon={Icons.Circuit}
          >
            {messages.itemAdministraceZdroje()}
          </AppNavigationItem>
          <AppNavigationItem
            link={PATHS.ADMINISTRACE.KONFIGURACNI_PARAMETRY}
            icon={Icons.Configuration}
            renderable={userInfo.isUserInRole(["admin"])}
          >
            {messages.itemAdministraceKonfiguracniParametry()}
          </AppNavigationItem>
        </AppNavigation2g>
      </Authorized>
    </>
  );
}

export default React.memo(AppNavigation);
